import React from 'react';
import './TemplatePage.css';

function TemplateGridLayout() {
  return (
    <div className="template-page">
      <div className="template-hero">
        <div className="container">
          <h1>Template Grid Layout</h1>
          <p>Professional template with grid layout</p>
        </div>
      </div>

      <div className="container">
        <div className="template-layout grid-layout">
          <div className="template-content">
            <h2>Grid Layout Template</h2>
            <div className="grid-posts">
              <div className="grid-post">
                <div className="post-image">
                  <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop" alt="Grid Post 1" />
                </div>
                <div className="post-content">
                  <h3>Grid Post Title 1</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                </div>
              </div>

              <div className="grid-post">
                <div className="post-image">
                  <img src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77?w=400&h=250&fit=crop" alt="Grid Post 2" />
                </div>
                <div className="post-content">
                  <h3>Grid Post Title 2</h3>
                  <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                </div>
              </div>

              <div className="grid-post">
                <div className="post-image">
                  <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop" alt="Grid Post 3" />
                </div>
                <div className="post-content">
                  <h3>Grid Post Title 3</h3>
                  <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                </div>
              </div>

              <div className="grid-post">
                <div className="post-image">
                  <img src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77?w=400&h=250&fit=crop" alt="Grid Post 4" />
                </div>
                <div className="post-content">
                  <h3>Grid Post Title 4</h3>
                  <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#" className="footer-link active">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="#" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="../assets/bg-remover-logo.png" alt="ASK ME SPORTS ALLIANCE Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TemplateGridLayout;
